module.exports = __webpack_public_path__ + "media/Take My Hand.a3e05386.mp3";